import React, { useState, useCallback } from "react";
import { FaAngleDown, FaAngleUp } from "react-icons/fa";
import { SERVICES } from "../constants";

const Services = React.memo(() => {
	const [openItems, setOpenItems] = useState({ 1: true, 2: false, 3: false });

	const toggleItem = useCallback((itemId) => {
		setOpenItems(prev => ({
			...prev,
			[itemId]: !prev[itemId]
		}));
	}, []);

	return (
		<section id='Services' className='isolate bg-gray-900 py-20 sm:py-20' aria-labelledby='services-heading'>
			<div className='relative mx-auto max-w-7xl px-4 lg:px-16'>
				<div className='mx-auto grid max-w-2xl grid-cols-1 gap-y-16 gap-x-8 sm:gap-y-20 lg:mx-0 lg:max-w-none lg:grid-cols-2'>
					<header className='lg:pr-8'>
						<div className='md:max-w-lg md:pr-10 lg:max-w-lg lg:pr-30'>
							<div className='hidden sm:flex sm:justify-left'>
								<div className='border-b-8 border-white w-32 my-6' aria-hidden='true'></div>
							</div>
							<h2 id='services-heading' className='mt-2 text-4xl font-bold tracking-tight text-white sm:text-6xl text-center sm:text-left'>
								SERVICES I OFFER
							</h2>
							<p className='mt-6 text-lg leading-8 text-gray-400'>
								As a software engineer, I offer a variety of services to help
								businesses and individuals achieve their goals through
								technology. Here are some of the services I specialize in 👉
							</p>
						</div>

						<nav className='absolute left-26 z-50 pt-10 md:block hidden' aria-label='Scroll to portfolio'>
							<a href='#Portfolio' aria-label='Scroll down to portfolio section'>
								<div className='bg-white rounded-full p-6 cursor-pointer hover:bg-indigo-600 transition-colors'>
									<FaAngleDown size={26} aria-hidden='true' />
								</div>
							</a>
						</nav>
					</header>

					<div className='pt-0 md:pt-0' role='list' aria-label='Services offered'>
						{SERVICES.map((service, index) => (
							<article
								key={service.id}
								className={`${index < SERVICES.length - 1 ? 'border-b border-gray-200' : ''} pb-4 mb-4 ${index === 0 ? 'mt-4 sm:mt-4' : 'mt-4'}`}
								role='listitem'
							>
								<button
									className={`${index === 0 ? '' : 'mt-4'} w-full text-left text-4xl font-bold tracking-tight text-gray-300 flex items-center cursor-pointer hover:text-white transition-colors`}
									onClick={() => toggleItem(service.id)}
									aria-expanded={openItems[service.id]}
									aria-controls={`service-${service.id}-description`}
									aria-label={`Toggle ${service.title} service details`}
								>
									<span className='inline-block align-middle mr-2 text-6xl font-bold text-gray-200' aria-hidden='true'>
										{service.number}
									</span>
									<span className='font-medium align-middle'>
										{service.title}
									</span>
									{openItems[service.id] ? (
										<FaAngleDown className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' aria-hidden='true' />
									) : (
										<FaAngleUp className='h-8 w-8 ml-auto text-gray-900 bg-white rounded-full p-2' aria-hidden='true' />
									)}
								</button>
								{openItems[service.id] && (
									<div id={`service-${service.id}-description`} className='mt-4 text-base leading-6 text-gray-400'>
										<p>{service.description}</p>
									</div>
								)}
							</article>
						))}
					</div>
				</div>
			</div>
		</section>
	);
});

Services.displayName = 'Services';

export default Services;
